import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { DailyAttendancePrintComponent } from './daily-attendance-print/daily-attendance-print.component';
import { DailyAttendanceStaffComponent } from './daily-attendance-staff/daily-attendance-staff.component';
import { EmployeeAdvanceComponent } from './employee-advance/employee-advance.component';
import { EmployeeSalaryMappingComponent } from './employee-salary-mapping/employee-salary-mapping.component';
import { EmployeeShiftMappingComponent } from './employee-shift-mapping/employee-shift-mapping.component';
import { MonthlyAttendancePrintComponent } from './monthly-attendance-print/monthly-attendance-print.component';
import { MonthlyAttendanceStaffPrintComponent } from './monthly-attendance-staff-print/monthly-attendance-staff-print.component';
import { MonthlyAttendanceStaffComponent } from './monthly-attendance-staff/monthly-attendance-staff.component';
import { StaffTimeAttendanceComponent } from './monthly-attendance/staff-time-attendance.component';
import { PaymentModeComponent } from './payment-mode/payment-mode.component';
import { SalaryCalculationComponent } from './salary-calculation/salary-calculation.component';
import { SalaryComponentComponent } from './salary-component/salary-component.component';
import { SalaryListPrintComponent } from './salary-list-print/salary-list-print.component';
import { SalaryMonthComponent } from './salary-month/salary-month.component';
import { SalaryPrintComponent } from './salary-print/salary-print.component';
import { ShiftComponent } from './shift/shift.component';
import { StaffAllowancesComponent } from './staff-allowances/staff-allowances.component';
import { StaffAttendanceSummaryPrintComponent } from './staff-attendance-summary-print/staff-attendance-summary-print.component';
import { StaffAttendanceSummaryComponent } from './staff-attendance-summary/staff-attendance-summary.component';


const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [

     
      { path: 'salarycomponent', component: SalaryComponentComponent, pathMatch: 'full' },
      { path: 'employeesalarypaymentmode', component: PaymentModeComponent, pathMatch: 'full' },
      { path: 'employeesalarymapping', component: EmployeeSalaryMappingComponent, pathMatch: 'full' },
      { path: 'dailyattendancestaff', component: DailyAttendanceStaffComponent, pathMatch: 'full' },
      { path: 'employee-monthwise-attendance', component: StaffTimeAttendanceComponent, pathMatch: 'full' },
      { path: 'monthlyattendancestaff', component: MonthlyAttendanceStaffComponent, pathMatch: 'full' },
      { path: 'staffattendancesummary', component: StaffAttendanceSummaryComponent, pathMatch: 'full' },
      { path: 'staffallowances', component: StaffAllowancesComponent, pathMatch: 'full' },
      { path: 'employeeadvance', component: EmployeeAdvanceComponent, pathMatch: 'full' },
      { path: 'salarycalculation', component: SalaryCalculationComponent, pathMatch: 'full' },
      { path: 'salary-month', component: SalaryMonthComponent, pathMatch: 'full' },
      { path: 'shift', component: ShiftComponent, pathMatch: 'full' },
      { path: 'employee-shift-mapping', component: EmployeeShiftMappingComponent, pathMatch: 'full' },     
    

    ]
  },
  {
    path: '', children: [
      { path: 'DailyAttendancePrint', component: DailyAttendancePrintComponent, pathMatch: 'full' },
      { path: 'MonthWiseAttendancePrint', component: MonthlyAttendancePrintComponent, pathMatch: 'full' },
      { path: 'MonthlyAttendancePrint', component: MonthlyAttendanceStaffPrintComponent, pathMatch: 'full' },
      { path: 'AttendanceSummaryPrint', component: StaffAttendanceSummaryPrintComponent, pathMatch: 'full' },
      { path: 'staffsalaryprint', component: SalaryPrintComponent, pathMatch: 'full' },
      { path: 'salarylistprint', component: SalaryListPrintComponent, pathMatch: 'full' }

    ]
  }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HRRoutingModule { }
